import React from "react";
import { Link } from "react-router-dom";
import Image from "../components/elements/Image";
import FooterImage from "../assets/images/footer-image.svg";
import LogoWhite from "../assets/images/Memory_Doodle_White.svg";
import { classNames } from "../helpers/classNames";
import { useSelector } from "react-redux";

const DefaultFooter = () => {
  const { siteSetting } = useSelector((state) => state.setting);
  const socialData = siteSetting?.social;

  return (
    <>
      <footer className="relative flex items-center transition-all duration-300 h-24 bg-md-pink-light-1 border-t border-md-pink-light-1">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl mx-auto px-4 lg:px-20">
          <div className="flex items-center gap-1 md:gap-2 lg:gap-10 justify-between flex-col lg:flex-row">
            <div className="r text-neutral-500 text-sm sm:text-base 2xl:text-lg ">
              &copy;
              {siteSetting?.copyright || " 2025 Memory Doodle. All rights reserved. Create memories, one doodle at a time."}
            </div>
            <div className="flex flex-shrink-0 divide-x divide-slate-400 gap-2">
              <div className="flex">
                <a href="/terms-and-conditions" className="text-neutral-500 inline-block hover:text-neutral-700 text-sm sm:text-base 2xl:text-lg  !leading-none">
                  Terms & Conditions
                </a>
              </div>
              <div className="flex pl-2">
                <a href="/privacy-policy" className="text-neutral-500 inline-block hover:text-neutral-700 text-sm sm:text-base 2xl:text-lg  !leading-none">
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default DefaultFooter;
